import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/provider-actions';
import { ProgramBookActions } from '../constants';
import { IProgramBookAnswers } from 'src/types/programBookAnswers';

export interface ProgramBookAnswersState {
    inProgress: boolean;
    inProgressAnswers: boolean | null;
    error: string;
    data: Paginated<IProgramBookAnswers>;
    current: IProgramBookAnswers | null;
    miniLoaderFor: { [key: string]: boolean };
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    inProgressAnswers: false,
    authCode: '',
    miniLoaderFor: {},
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function programBookAnswers(
    state: ProgramBookAnswersState = initialState,
    action: Actions | any,
): ProgramBookAnswersState {
    switch (action.type) {
        case requestType(ProgramBookActions.PROGRAM_BOOK_ANSWERS_PERSIST):
            return { ...state, error: '', inProgress: true, inProgressAnswers: true };
        case successType(ProgramBookActions.PROGRAM_BOOK_ANSWERS_PERSIST):
            return { ...state, inProgress: false, inProgressAnswers: false };
        case failureType(ProgramBookActions.PROGRAM_BOOK_ANSWERS_PERSIST):
            return { ...state, error: action.error, inProgress: false, inProgressAnswers: false };
        case requestType(ProgramBookActions.PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST):
            return { ...state, error: '', inProgress: true, inProgressAnswers: true };
        case successType(ProgramBookActions.PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST):
            return { ...state, inProgress: false, inProgressAnswers: false };
        case failureType(ProgramBookActions.PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST):
            return { ...state, error: action.error, inProgress: false, inProgressAnswers: false };
        case requestType(ProgramBookActions.PROGRAM_BOOK_ANSWERS_FETCH):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProgramBookActions.PROGRAM_BOOK_ANSWERS_FETCH):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProgramBookActions.PROGRAM_BOOK_ANSWERS_FETCH):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        default:
            return state;
    }
}
